import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "lola-framework-ui-test/src/styles";
import "./lola-quote-reset.css";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import "./locales/i18n.ts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
